 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~73430e6b","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-es-json","12":"source~/esports-betting-rules-TR","13":"source~bet-builder-rules-DE","14":"source~bet-builder-rules-EN","15":"source~bet-builder-rules-ES","16":"source~bet-builder-rules-ES-MX","17":"source~bet-builder-rules-ET","18":"source~bet-builder-rules-FI","19":"source~bet-builder-rules-FR","20":"source~bet-builder-rules-IT","21":"source~bet-builder-rules-JA","22":"source~bet-builder-rules-KA","23":"source~bet-builder-rules-LT","24":"source~bet-builder-rules-LV","25":"source~bet-builder-rules-PL","26":"source~bet-builder-rules-PT-BR","27":"source~bet-builder-rules-RO","28":"source~bet-builder-rules-RU","29":"source~bet-builder-rules-SQ","30":"source~bet-builder-rules-TR","31":"source~bet-details-page","32":"source~betting-history-container","33":"source~betting-history-page","34":"source~betting-rules-DA","35":"source~betting-rules-DE","36":"source~betting-rules-EN","37":"source~betting-rules-ES","38":"source~betting-rules-ES-MX","39":"source~betting-rules-FR","40":"source~betting-rules-IT","41":"source~betting-rules-JA","42":"source~betting-rules-PL","43":"source~betting-rules-PT","44":"source~betting-rules-PT-BR","45":"source~betting-rules-RO","46":"source~betting-rules-RU","47":"source~betting-rules-SQ","48":"source~betting-rules-TR","49":"source~cashout-terms-AR","50":"source~cashout-terms-DA","51":"source~cashout-terms-DE","52":"source~cashout-terms-EN","53":"source~cashout-terms-ES","54":"source~cashout-terms-ES-MX","55":"source~cashout-terms-ET","56":"source~cashout-terms-FI","57":"source~cashout-terms-FR","58":"source~cashout-terms-IT","59":"source~cashout-terms-JA","60":"source~cashout-terms-KA","61":"source~cashout-terms-KU","62":"source~cashout-terms-LT","63":"source~cashout-terms-LV","64":"source~cashout-terms-PL","65":"source~cashout-terms-PT","66":"source~cashout-terms-PT-BR","67":"source~cashout-terms-RO","68":"source~cashout-terms-RU","69":"source~cashout-terms-SQ","70":"source~cashout-terms-SR","71":"source~cashout-terms-TR","72":"source~esports-betting-rules-DA","73":"source~esports-betting-rules-DE","74":"source~esports-betting-rules-EN","75":"source~esports-betting-rules-ES","76":"source~esports-betting-rules-ES-MX","77":"source~esports-betting-rules-ET","78":"source~esports-betting-rules-FI","79":"source~esports-betting-rules-FR","80":"source~esports-betting-rules-IT","81":"source~esports-betting-rules-JA","82":"source~esports-betting-rules-KA","83":"source~esports-betting-rules-LT","84":"source~esports-betting-rules-LV","85":"source~esports-betting-rules-PL","86":"source~esports-betting-rules-PT","87":"source~esports-betting-rules-PT-BR","88":"source~esports-betting-rules-RO","89":"source~esports-betting-rules-RU","90":"source~esports-betting-rules-SQ","91":"source~esports-betting-rules-SR","92":"source~generated-mappings","93":"source~i18n-en-json","94":"source~i18n-es-json","96":"source~settings-page","97":"source~streaming-carousel","98":"source~virtual-esports-betting-rules-EN","99":"source~virtual-esports-betting-rules-IT","100":"source~virtual-esports-betting-rules-JA","101":"source~virtual-esports-betting-rules-PL","103":"vendors~rc-slider","104":"vendors~react-google-recaptcha","105":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"11f7c7289ab1619cf211","1":"67e55094ee3a467a83d2","2":"ee1e1e531bc4c97dfd86","3":"626ea9e855f4fcda08d5","4":"5fffdb062a19a52a7a07","5":"e046812e0a1101b7339f","6":"1630a33825cf752f4b80","7":"da46c1138966a4204a0b","8":"6f4c03b213a2c7630f6b","9":"fbd409e148d54e98dd46","12":"8e195712b93148c62255","13":"1ac3afcefb7f7bcc25ba","14":"ad245d6039d906856bf6","15":"59ff6315ab36aedc9295","16":"ddd3b42d53ae8b7492ce","17":"5ed142ccc4a974b11ed6","18":"aba82bbe3ab19306eb59","19":"8e8fa1a44d62f826ffe0","20":"46125f1e0842877d7b9c","21":"4e1bd3ae4fdf057ee72e","22":"f77b269f2cf008a42ec7","23":"32d2a6748221be61f539","24":"0700ec9cf727a81a49c2","25":"b3d4de3e55a75c9f2ea5","26":"1819da6e7081c95f3739","27":"6eb568fdcb50fa5ee43d","28":"5ef153e8cc97c9580165","29":"446f2c52b555feed0221","30":"ee0b8ecab8805d1e1cda","31":"2fbbe51eb19f7db9dc98","32":"51301408bf348111ae15","33":"7a8dbb26a2212ef898b0","34":"048cb2651c139bbc0969","35":"9c477265b042b55b9a4c","36":"f19c9e2f187f28afb742","37":"84c4b6eacf71412f8bcc","38":"e2957da925430b0b0cf2","39":"d81a18fa1546fea18945","40":"fa1a925cfffb6319740e","41":"f3527f8ea8b0669b9257","42":"8723c176bee5c57959e9","43":"267c6ddb99dd18953a2c","44":"261e1a430a0c8e7cc32a","45":"8ef824a3a4cee181941d","46":"a22ab1f907c0b28c2f04","47":"a1636981f288dd9a63b8","48":"a8c16b97ec8522bbbaa8","49":"65250d9b66afb7a2480e","50":"f895cda48d89d0f35832","51":"28f450a548f86f16c652","52":"183fe367c5f0cfa68dfd","53":"67187add747da9c58589","54":"8e8834f41b15e57ef87d","55":"62e294257902c3b68ebb","56":"57fe3479d8a824fb986d","57":"050719e3eca6135694ce","58":"940a92da4dde0835dfe8","59":"917c66b251c18ea053f4","60":"bc528ebc6d9297e9db2e","61":"0aacffd02ae1c44a718b","62":"608740c6bb90ee2e5875","63":"450d0fcfe2574dd34aa1","64":"d547a0cd80aaa1301545","65":"fd0e3d81f861543b4808","66":"161b692493d055fa8ad8","67":"a4ba1c5e5f6f78d556bf","68":"e0022c80f6b0390e84d5","69":"c7b5fe7c673999d13d4c","70":"3d6b91a13b8e8ccff1a8","71":"9be9d390e15ca22f4b66","72":"0451aea1bc31c1a50f64","73":"901c9f8673d75fe40b35","74":"88f1e14fdd1cd340880e","75":"0ad165086b2f924307cb","76":"23fec437ba9879266672","77":"46d92a6c65542a54aaa4","78":"375a745308bc7543de26","79":"f7ddb6dc3614207c085c","80":"cbe10defda7beeeb6309","81":"71e4104194b8938d3d39","82":"77bfa7885f7fc810c2d6","83":"141b72438419f0d59f7d","84":"c83f094513f5e3786b46","85":"17bcf757a0e53cf177cb","86":"844bc8b9d0cf2ba06c57","87":"a36fd508113e58988aad","88":"32773da30b1a6d35624a","89":"64467c63e0f3b93cd447","90":"6331141cb041a917b781","91":"0a77464d297a97a4788a","92":"f0941f85a557348bf156","93":"7ad991af26cc86302213","94":"15e32fcbbdb84147915c","96":"acad306818d0acef87fa","97":"ea84bbfd52f353ebb21a","98":"ddb0d742e03917121fc6","99":"1d60dc7c85d4dd7fd5c7","100":"77e43e338d29672e15ec","101":"eefe12058bd177a7d227","103":"c4d558b4cb05dfde0cf1","104":"51d0f86f2958f9beacaf","105":"5ae8a4eb65122976cb39","106":"ef6e6d7191ad37224788","107":"ded844e63c7a5614d672","108":"006e3f86742add0dc83d","109":"3a276f36463541875d98","110":"7a1a7c69af6b54027b47","111":"c6ce634c261891424f73","112":"663836fefd3d0423dd0c","113":"6d7062e20b723db0c8a6","114":"3917024a21a3dcc4e45a","115":"2a5770f22699acbd044b","116":"c78d3f69a4144c5e26e3","117":"fe0e07ec466a007cc384","118":"481373718b0e18f97e7a","119":"7c448b8f26839e180bd1","120":"5af7bef7793e583251ed","121":"392b46193c6c16073c51","122":"b063ecaaad8fbe66c6ab","123":"ea991d7045bb6b630531","124":"c51b17afc4e389dc66f5","125":"326f88e88074d93c4cc8","126":"a6fd81f2ffc67098c822","127":"cd674268c8fc4f542c92","128":"ace3a0730cf1bc1d3ce8","129":"ab52870ab984f30bb476","130":"6895b83de369326d3cf5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
